import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { Appointments } from '@devexpress/dx-react-scheduler-material-ui';

const AppointmentContent = (props) => {
    const { data } = props;

	return (
        <Appointments.AppointmentContent {...props}>
            <div>
                <Typography variant="subtitle2" display="block">
                    {data?.worker?.firstName} {data?.worker?.lastName}
                </Typography>
                <Typography variant="caption" style={{ marginRight: 4 }}>
                    {(data?.startDate).toLocaleTimeString('sr', { hour: '2-digit', minute:'2-digit' })}
                </Typography>
                    -
                <Typography variant="caption" style={{ marginLeft: 4 }} >
                    {(data?.endDate).toLocaleTimeString('sr', { hour: '2-digit', minute:'2-digit' })}
                </Typography>
                <Typography variant="caption" display="block">
                    {data?.customer?.firstName} {data?.customer?.lastName}
                </Typography>
            </div>
        </Appointments.AppointmentContent>
    );
};

AppointmentContent.propTypes = {
    data: PropTypes.object.isRequired
}

export default AppointmentContent;
